import {createSelector} from 'reselect';

const getRootAlert = (state: any) => state.alert;

export const selectrootalerttype = createSelector(
  [getRootAlert],
  modal => modal,
);
